<template>
  <!-- Top recepti (bocna kolona na stranicama recepata): recepti oznaceni kao top, sa slikom, padajuca lista kategorija -->
  <RecipesBlock
    :items="items"
    :filter="{ top_recipe: true }"
    :limit="8"
    title="TOP RECEPTI"
    dropdown="category"
  />
</template>

<script setup>
import RecipesBlock from '~/components/widgets/Recipe/RecipesBlock.vue'

defineProps({
  items: { type: Array, default: () => [] },
})
</script>
